












import Vue from 'vue';

enum NotIn {
  No = 0,
  Yes = 1,
}

export default Vue.extend({
  props: {
    value: Number,
  },
  data() {
    return {
      localValue: 0,
      loaded: false,
    };
  },
  methods: {
    updateRelation(notIn: number) {
      this.$emit('change', notIn === 1);
    },
  },
  mounted() {
    this.localValue = this.value;
    this.loaded = true;
  },
});
